import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { of, tap } from "rxjs";
import { ApiClientService } from "~app/common/services/api-client.service";
import { DokumentUrlDTO } from "~app/pages/dokument/model/DokumentUrlDTO";

export const dokumentVirkeskopKontraktResolver: ResolveFn<DokumentUrlDTO> = (route, _state) => {
    const apiClientService = inject(ApiClientService);
    const kontraktId = route.paramMap.get("id");
    const dokumentId = route.paramMap.get("dokumentId");

    if (!kontraktId || !dokumentId) {
        return of(new DokumentUrlDTO());
    }

    return apiClientService
        .get<DokumentUrlDTO>(`/virkeskop2/${kontraktId}/dokument/${dokumentId}`)
        .pipe(
            tap((dto: DokumentUrlDTO) => {
                if (dto?.url) {
                    window.location.href = dto.url;
                }
            })
        );
};
